import { createContext, useContext, useEffect, useState } from 'react';

// Standalone pages/tests default to visible. Retained workspace pages receive
// their actual visibility independently of their frozen router location.
export const PageVisibility = createContext(true);
export default function usePageVisible() {
  const pageVisible = useContext(PageVisibility);
  const [tabVisible, setTabVisible] = useState(() => document.visibilityState !== 'hidden');
  useEffect(() => {
    const update = () => setTabVisible(document.visibilityState !== 'hidden');
    document.addEventListener('visibilitychange', update);
    return () => document.removeEventListener('visibilitychange', update);
  }, []);
  return pageVisible && tabVisible;
}
